function openRefundModal(e) {
    if (e) e.preventDefault();
    var overlay = document.getElementById('refund-policy-modal');
    overlay.classList.add('rp-open');
    overlay.setAttribute('aria-hidden', 'false');
    document.body.style.overflow = 'hidden';
  }

  function closeRefundModal() {
    var overlay = document.getElementById('refund-policy-modal');
    overlay.classList.remove('rp-open');
    overlay.setAttribute('aria-hidden', 'true');
    document.body.style.overflow = '';
  }

  document.addEventListener('DOMContentLoaded', function () {
    var overlay = document.getElementById('refund-policy-modal');
    if (overlay) {
      overlay.addEventListener('click', function (e) {
        if (e.target === this) closeRefundModal();
      });
    }
});